module.exports = __webpack_public_path__ + "static/media/citrus_color_white.88ebc9b6.svg";